import { HelperService } from "./HelperService";

export class HistoryService extends HelperService {}
